var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Controller } from "stimulus";
var GoogleMaps = /** @class */ (function (_super) {
    __extends(GoogleMaps, _super);
    function GoogleMaps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleMaps.prototype.initialize = function () {
        if (GoogleMaps.INITIALIZED) {
            return;
        }
        console.log("[initialize] GoogleMaps");
        // Create the script tag, set the appropriate attributes
        var script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&callback=initMap";
        script.defer = true;
        script.async = true;
        // Attach your callback function to the `window` object
        window.initMap = function () {
            // JS API is loaded and available
            console.log("initMap");
        };
        // Append the 'script' element to 'head'
        document.head.appendChild(script);
        GoogleMaps.INITIALIZED = true;
    };
    GoogleMaps.prototype.connect = function () {
        console.log("[connect] GoogleMaps");
    };
    GoogleMaps.prototype.disconnect = function () {
        console.log("[disconnect] GoogleMaps");
    };
    GoogleMaps.INITIALIZED = false;
    return GoogleMaps;
}(Controller));
export default GoogleMaps;
